/**
 * utils/unitCode.js — Бүтцийн нэгжийн КОДООС БН ба ХЭСГИЙГ тайлах.
 *
 * КОДЫН БҮТЭЦ:
 *   ЦЕХ    2 орон  («25» = ХМТАЦ, «11» = Баяжуулах үйлдвэр)
 *   ХЭЛТЭС 4 орон  («0107» = ХАБЭА хэлтэс — «01» удирдлагын нэгжүүд)
 *   хэсэг / групп нь илүү урт («2505», «250501», «1141» …)
 *
 * ⚠ НЭРЭЭР бүлэглэж БОЛОХГҮЙ. Нэг нэгж хэд хэдэн нэртэй бичигддэг
 *   («0107» → «ХАБЭА хэлтэс» ба «Хөдөлмөрийн аюулгүй байдал…хэлтэс»),
 *   мөн БН-ийн талбарт ХЭСГИЙН нэр орсон бүртгэл бий. Тиймээс бүлэглэлт
 *   ҮРГЭЛЖ кодоор явна.
 *
 * ⚠ ЭНЭ ДҮРЭМ ГУРВАН ТАЛД ИЖИЛ БАЙХ ЁСТОЙ:
 *     вэб      — энэ файл
 *     backend  — Flask/Utils/unit_split.py · bn_key()
 *     HRT тайлагч — Flask/Models/highrisk/hr_reference.py
 *   Зөрвөл нэг л хуудсан дээр групплэлт чимээгүй эвдэрнэ.
 */

/** Кодоос БН-ийн түлхүүр. Хоосон код → хоосон мөр. */
export function bnKeyOf(code) {
  const d = String(code || "").replace(/\D/g, "");
  if (!d) return "";
  return d.startsWith("01") ? d.slice(0, 4) : d.slice(0, 2);
}

/** Код нь БН-ийн доорх ХЭСЭГ эсэх (БН өөрөө бол false). */
export function isSectionCode(code) {
  const d = String(code || "").replace(/\D/g, "");
  return !!d && d.length > bnKeyOf(d).length;
}

/**
 * `{ tseh_code, negj_code }` — хамгийн доод нэгжийн кодыг салгана.
 *
 * Хэсэг сонгогдоогүй бол `negj_code` нь ХООСОН үлдэнэ — «тодорхойгүй
 * хэсэг» гэсэн хуурамч бүлэг үүсгэхгүй.
 */
export function splitUnitCode(code) {
  const raw = String(code || "").trim();
  const bn = bnKeyOf(raw);
  if (!bn) return { tseh_code: "", negj_code: "" };
  return { tseh_code: bn, negj_code: isSectionCode(raw) ? raw : "" };
}

/** `code` нь `parent`-ийн дор байна уу (угтвараар). Хоосон parent → тийм. */
export function isUnderUnit(code, parent) {
  const p = String(parent || "").replace(/\D/g, "");
  if (!p) return true;
  return String(code || "").replace(/\D/g, "").startsWith(p);
}
